/*
 * 80|100 visitor detection
 * - Detects the visitor's country with Shopify's own endpoint (/browsing_context_suggestions.json).
 * - Visitors outside Colombia see the Export menu link and the Export teaser (html.eighty-intl).
 * - On the first visit only, visitors from outside Spanish-speaking countries are sent to the
 *   English version (/en/...). After that their own choice in the language selector always wins.
 */
(function () {
  var STORE_COUNTRY = 'eighty_country';
  var STORE_LANG_DONE = 'eighty_lang_done';
  var SPANISH = ['CO', 'MX', 'AR', 'CL', 'PE', 'EC', 'VE', 'BO', 'PY', 'UY', 'CR', 'PA', 'GT', 'HN', 'SV', 'NI', 'DO', 'CU', 'PR', 'ES', 'GQ'];
  var root = document.documentElement;

  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage blocked: detection still works per page */ }
  }

  function isBot() {
    return navigator.webdriver || /bot|crawl|spider|slurp|facebookexternalhit|lighthouse|pingdom/i.test(navigator.userAgent);
  }

  function hideExportLinksFallback() {
    // Browsers without :has() support: hide the list items that hold Export links.
    if (window.CSS && CSS.supports && CSS.supports('selector(:has(a))')) return;
    document.querySelectorAll('a[href*="/pages/export"]').forEach(function (a) {
      if (a.closest('.eighty')) return;
      var li = a.closest('li');
      if (li) li.style.display = 'none';
    });
  }

  function applyCountry(country) {
    root.setAttribute('data-visitor-country', country || '');
    if (country && country !== 'CO') {
      root.classList.add('eighty-intl');
    } else {
      root.classList.remove('eighty-intl');
      hideExportLinksFallback();
    }
  }

  function maybeSwitchLanguage(country) {
    if (!country || isBot() || read(STORE_LANG_DONE)) return;
    write(STORE_LANG_DONE, '1');
    var locale = (window.Shopify && Shopify.locale) || root.lang || '';
    var langs = window.eightyLanguages || [];
    var wantsEnglish = SPANISH.indexOf(country) === -1;
    if (wantsEnglish && locale.indexOf('es') === 0 && langs.indexOf('en') !== -1) {
      var path = window.location.pathname;
      if (path.indexOf('/en/') === 0 || path === '/en') return;
      window.location.replace('/en' + (path === '/' ? '' : path) + window.location.search + window.location.hash);
    }
  }

  // Test override: add ?eighty_country=US to any URL to see the site as a visitor from that
  // country; ?eighty_country=reset goes back to automatic detection.
  var forced = null;
  try {
    var q = new URLSearchParams(window.location.search).get('eighty_country');
    if (q) {
      if (q.toLowerCase() === 'reset') { window.localStorage.removeItem(STORE_COUNTRY); }
      else { forced = q.toUpperCase(); write(STORE_COUNTRY, forced); write(STORE_LANG_DONE, '1'); }
    }
  } catch (e) { /* ignore */ }

  // Apply the cached country right away so the Export link does not flicker.
  var cached = forced || read(STORE_COUNTRY);
  if (cached) applyCountry(cached);

  document.addEventListener('DOMContentLoaded', function () {
    if (!cached) hideExportLinksFallback();
    if (forced) return;
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!country) return;
        country = String(country).toUpperCase();
        write(STORE_COUNTRY, country);
        applyCountry(country);
        maybeSwitchLanguage(country);
      })
      .catch(function () { /* detection unavailable: site stays in the primary language, no Export link */ });
  });
})();
